export default function Home() {
  const queryParams = new URLSearchParams(window.location.search)
  const uuid = queryParams.get('uuid')

  return (
    <div id="capture" className="capture w-screen">
      <p>Reports</p>
      <p>uuid: {uuid}</p>
    </div>
  )
}
